import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
} from '../index';
import {
  getObject,
} from '../../utils/listsSelect';
import {
  doPut,
  doGetFile,
  trataMensagensErro,
  trataMensagemSucesso,
  doDelete,
} from '../../utils/requests';
import ModalTipoDocumento from '../../pages/requerimentos/ModalTipoDocumento';
import { msgsConfirmacaoExclusaoDocumentoRequerimento } from '../../utils/constants';
import ModalAlerta from '../../pages/requerimentos/ModalAlerta';
import User from '../../domain/User';

class DocumentControlItem extends Component {
  constructor() {
    super();
    this.state = {
      showTipoDocumentoModal: null,
      showModalAlerta: false,
      exclusaoDocumento: null,
    };
  }

  handleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  }

  handleClose = () => {
    this.setState({ document: null }, this.handleModal('showTipoDocumentoModal'));
  }

  downloadDocument = (filename) => {
    doGetFile(this.props.document.key, filename);
  }

  confirmaExclusaoArquivo = () => {
    const idArquivo = this.props.document.key;
    doDelete(
      'documentos/excluirDocumento',
      idArquivo,
      this.trataSucessoResponseExclusaoArquivo,
      this.trataErrosResponse,
      '',
    );
    this.setState(() => this.handleFechamentoModalAlerta());
  }

  trataSucessoResponseExclusaoArquivo = () => {
    const mensagemSucesso = ['Documento excluído com sucesso.'];
    trataMensagemSucesso(mensagemSucesso);
    this.props.atualizarDocumentosProbatorios();
  }

  trataErrosResponseExclusaoArquivo = () => {
    const mensagemErro = ['Não foi possível excluir o arquivo.'];
    trataMensagensErro(mensagemErro);
  }

  /**
 * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
 */
  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  trataSucessoResponseEnvio = () => {
    this.handleModal('showTipoDocumentoModal');
    if (this.props.acao === 'indeferidos') {
      const mensagemSucesso = ['Documento alterado com sucesso.'];
      trataMensagemSucesso(mensagemSucesso);
    }
    this.props.atualizarDocumentosProbatorios();
  }

  trataErrosResponse = () => {
    if (this.props.acao === 'indeferidos') {
      const mensagemErro = ['Não foi possível alterar o documento.'];
      trataMensagensErro(mensagemErro);
    }
  }

  alterarTipoDocumento = (paramTipoDocumento) => {
    const tipoDocumento = {
      protocolo: this.props.requerimento.protocolo,
      codigo: paramTipoDocumento,
    };
    doPut(
      `documentos/${this.props.document.key}`,
      tipoDocumento,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
    );
  }

  render() {
    let documentType = 'Carregando...';

    if (this.props.tiposDocumentos) {
      documentType = getObject(
        this.props.tiposDocumentos,
        this.props.document.documentType,
      );
    }
    if (this.props.document.key) {
      return (
        <div className="row">
          <Grid cols="7 7 7 7">
            {(this.props.auth.checkPermission(['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-negocio-sprev', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps', 'fornecer-parecer-medico-rpps', 'gerenciar-negocio-dcomp'])) ?
                <Button
                  hint={documentType.label}
                  icon="ico-download"
                  onClick={() => this.downloadDocument(documentType.label)}
                />
              :
                <Button
                  hint={documentType.label}
                  icon="ico-cancel-circle"
                />
            }
            <span>{documentType.label}</span>
          </Grid>
          <Grid cols="3 3 3 3">
            {((this.props.requerimento.estado === 15 && this.props.acao === 'indeferidos') || (this.props.requerimento.estado === 2 && this.props.acao === 'cumprir-exigencia')) ?
              <Button
                hint="Alterar o tipo do documento"
                icon="ico-pencil"
                className="icone"
                onClick={() => this.handleModal('showTipoDocumentoModal')}
              />
            : ''}
            {((this.props.requerimento.solicitante.cnpj === User.logged().cnpjDoPapel() ||
            (User.logged().isRGPS() && this.props.requerimento.solicitante.codigo === '01000')) &&
              ((this.props.requerimento.estado === 4 && this.props.acao === 'consulta')
            || (this.props.requerimento.estado === 5 && this.props.acao === 'consulta')
            || (this.props.requerimento.estado === 2 && this.props.acao === 'cumprir-exigencia'))) ?
              <Button
                hint="Excluir documento"
                icon="ico-trash-can"
                className="icone"
                onClick={() => this.handleModal('showModalAlerta')}
              />
              : ''}
          </Grid>
          {this.state.showTipoDocumentoModal ? (
            <ModalTipoDocumento
              {...this.props}
              requerimento={this.props.requerimento}
              alterarTipoDocumento={this.alterarTipoDocumento}
              handleModal={() => this.handleModal('showTipoDocumentoModal')}
              showModal={this.state.showTipoDocumentoModal}
              tiposDocumentos={this.props.tiposDocumentos}
            />
          ) : ''}
          {this.state.showModalAlerta ? (
            <ModalAlerta
              alertas={[msgsConfirmacaoExclusaoDocumentoRequerimento.exclusao]}
              aceitar={this.confirmaExclusaoArquivo}
              handleModal={this.handleFechamentoModalAlerta}
              showModal={this.state.showModalAlerta}
            />
          ) : ''}
        </div>
      );
    }
    return '';
  }
}

DocumentControlItem.propTypes = {
  document: PropTypes.shape({
    key: PropTypes.string,
    documentType: PropTypes.number,
  }).isRequired,
  protocolo: PropTypes.string.isRequired,
  tiposDocumentos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })).isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  estado: PropTypes.string.isRequired,
  atualizarDocumentosProbatorios: PropTypes.func.isRequired,
  tipoRequerimento: PropTypes.number.isRequired,
};

export default DocumentControlItem;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/DocumentControlItem.jsx